import React, { useEffect, useReducer } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { AuthConsumer } from "../lib/contexts/AuthContext";
import { WithApiAccess } from "../lib/HigherOrderComponents/WithApiAccess";

const ImpersonateUser = (props) => {
  const initialState = {
    searchTerm: "",
    list: [],
    isLoading: true,
  };

  const reducer = (state, action) => {
    switch (action.type) {
      case "searchTerm":
        return {
          ...state,
          searchTerm: action.payload,
        };
      case "list":
        return {
          ...state,
          list: action.payload,
        };
      case "isLoading":
        return {
          ...state,
          isLoading: true,
        };
      default:
        throw new Error();
    }
  };

  const [impersonateState, dispatch] = useReducer(reducer, initialState);
  const navigate = useNavigate();

  useEffect(() => {
    function impersonateUser() {
      props.api
        .get("/api/impersonation")
        .then((response) => {
          dispatch({ type: "list", payload: response.data });
        })
        .catch(hideLoader())
        .then(hideLoader());
    }
    impersonateUser();
  }, []);

  const handleSearchChanged = (event) => {
    dispatch({ type: "searchTerm", payload: event.target.value });
  };

  const hideLoader = () => {
    dispatch({ type: "isLoading", payload: false });
  };

  const submit = async (authContext) => {
    let impersonate = { usernametoimpersonate: impersonateState.searchTerm };
    await props.api
      .post("api/impersonation/impersonate", { ...impersonate })
      .then((response) => {
        if (response.status === 200) {
          delete localStorage["cp_nav_user_card"];
          authContext.loggedIn(
            response.data.id,
            response.data.username,
            response.data.accessToken,
            response.data.refreshToken,
            response.data.claims,
            () => {
              navigate("/home");
            },
          );
        }
        throw new Error("Failed. Please try again.");
      })
      .catch((error) => {
        console.log("Error " + error.message);
      });
  };

  const { searchTerm, list } = impersonateState;
  return (
    <AuthConsumer>
      {(context) => (
        <Container>
          <Row className="col-sm-4">
            <Col className="input-group " style={{ padding: "15px" }}>
              <input
                type="text"
                name="searchCriteria"
                value={searchTerm}
                onChange={handleSearchChanged}
                className="form-control"
                placeholder="Enter Username"
                list="users"
              />
              <span className="input-group-btn">
                <button
                  className="btn btn-sec btn-default"
                  onClick={() => submit(context)}
                  type="button"
                >
                  Impersonate
                </button>
              </span>
              <datalist id="users">
                {list && list.map((user, i) => <option key={i} value={user} />)}
              </datalist>
            </Col>
          </Row>
        </Container>
      )}
    </AuthConsumer>
  );
};

export default WithApiAccess(ImpersonateUser);
